// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var inject = allVue.inject;
import { MultiDayView } from '../day/MultiDayView';
import { DAYS_IN_WEEK_COUNT } from '../../constants/main';
import { Day, getDate, addDays, ZonedDate, firstDayInWeek } from '@progress/kendo-date-math';
import { weekViewTitle, messages } from '../../messages/main';
import { toUTCDateTime } from '../../utils/main';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
/** @hidden */
var WeekViewVue2 = {
  name: 'KendoWeekView',
  // @ts-ignore
  emits: {
    dataaction: null
  },
  props: {
    name: {
      type: String,
      default: 'week'
    },
    slotDuration: {
      type: Number,
      default: 60
    },
    slotDivisions: {
      type: Number,
      default: 2
    },
    numberOfDays: {
      type: Number,
      default: DAYS_IN_WEEK_COUNT
    },
    dateRange: {
      type: [Function, Object],
      default: function _default() {
        return weekViewDateRange;
      }
    },
    title: String,
    selectedDateFormat: {
      type: String,
      default: '{0:D} - {1:D}'
    },
    selectedShortDateFormat: {
      type: String,
      default: '{0:d} - {1:d}'
    },
    showWorkHours: {
      type: Boolean,
      default: true
    },
    currentTimeMarker: {
      type: Boolean,
      default: true
    },
    startTime: {
      type: String,
      default: '00:00'
    },
    endTime: {
      type: String,
      default: '23:59'
    },
    workDayStart: {
      type: String,
      default: '08:00'
    },
    workDayEnd: {
      type: String,
      default: '17:00'
    },
    workWeekStart: {
      type: Number,
      default: Day.Monday
    },
    workWeekEnd: {
      type: Number,
      default: Day.Friday
    },
    defaultShowWorkHours: {
      type: Boolean,
      default: true
    },
    dateHeaderCell: [String, Function, Object],
    timeHeaderCell: [String, Function, Object],
    slotRender: [String, Function, Object],
    viewSlot: [String, Function, Object],
    resizeHint: [String, Function, Object],
    item: [String, Function, Object],
    viewItem: [String, Function, Object],
    editable: {
      type: [Boolean, Object],
      default: false
    },
    format: String
  },
  inject: {
    kendoLocalizationService: {
      default: null
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var localization = provideLocalizationService(this);
    var title = localization.toLanguageString(weekViewTitle, messages[weekViewTitle]);
    return h(MultiDayView, {
      name: this.$props.name,
      attrs: this.v3 ? undefined : {
        name: this.$props.name,
        dateRange: this.$props.dateRange,
        numberOfDays: this.$props.numberOfDays,
        slotDuration: this.$props.slotDuration,
        slotDivisions: this.$props.slotDivisions,
        selectedDateFormat: this.$props.selectedDateFormat,
        selectedShortDateFormat: this.$props.selectedShortDateFormat,
        showWorkHours: this.$props.showWorkHours,
        title: title,
        step: DAYS_IN_WEEK_COUNT,
        currentTimeMarker: this.$props.currentTimeMarker,
        startTime: this.$props.startTime,
        endTime: this.$props.endTime,
        workDayStart: this.$props.workDayStart,
        workDayEnd: this.$props.workDayEnd,
        workWeekStart: this.$props.workWeekStart,
        workWeekEnd: this.$props.workWeekEnd,
        defaultShowWorkHours: this.$props.defaultShowWorkHours,
        dateHeaderCell: this.$props.dateHeaderCell,
        timeHeaderCell: this.$props.timeHeaderCell,
        slotRender: this.$props.slotRender,
        viewSlot: this.$props.viewSlot,
        resizeHint: this.$props.resizeHint,
        item: this.$props.item,
        slotItem: this.$props.slotItem,
        viewItem: this.$props.viewItem,
        editable: this.$props.editable
      },
      dateRange: this.$props.dateRange,
      numberOfDays: this.$props.numberOfDays,
      slotDuration: this.$props.slotDuration,
      slotDivisions: this.$props.slotDivisions,
      selectedDateFormat: this.$props.selectedDateFormat,
      selectedShortDateFormat: this.$props.selectedShortDateFormat,
      showWorkHours: this.$props.showWorkHours,
      title: title,
      step: DAYS_IN_WEEK_COUNT,
      currentTimeMarker: this.$props.currentTimeMarker,
      startTime: this.$props.startTime,
      endTime: this.$props.endTime,
      workDayStart: this.$props.workDayStart,
      workDayEnd: this.$props.workDayEnd,
      workWeekStart: this.$props.workWeekStart,
      workWeekEnd: this.$props.workWeekEnd,
      defaultShowWorkHours: this.$props.defaultShowWorkHours,
      dateHeaderCell: this.$props.dateHeaderCell,
      timeHeaderCell: this.$props.timeHeaderCell,
      slotRender: this.$props.slotRender,
      viewSlot: this.$props.viewSlot,
      resizeHint: this.$props.resizeHint,
      item: this.$props.item,
      slotItem: this.$props.slotItem,
      viewItem: this.$props.viewItem,
      editable: this.$props.editable,
      onDataaction: this.handleDataAction,
      on: this.v3 ? undefined : {
        "dataaction": this.handleDataAction
      }
    });
  },
  methods: {
    handleDataAction: function handleDataAction(action) {
      this.$emit('dataaction', action);
    }
  }
};
var GET_START_DATE = function GET_START_DATE(date) {
  return getDate(date);
};
var GET_END_DATE = function GET_END_DATE(start, numberOfDays) {
  return getDate(addDays(start, numberOfDays || 1));
};
var weekViewDateRange = function weekViewDateRange(_a) {
  var intl = _a.intl,
    date = _a.date,
    timezone = _a.timezone;
  var normalized = ZonedDate.fromLocalDate(date, timezone);
  var firstDate = GET_START_DATE(firstDayInWeek(normalized, intl.firstDay()));
  var lastDate = GET_END_DATE(firstDate, DAYS_IN_WEEK_COUNT);
  var zonedStart = ZonedDate.fromUTCDate(toUTCDateTime(firstDate), timezone);
  var zonedEnd = ZonedDate.fromUTCDate(toUTCDateTime(lastDate), timezone);
  var start = new Date(zonedStart.getTime());
  var end = new Date(zonedEnd.getTime());
  return {
    start: start,
    end: end,
    zonedStart: zonedStart,
    zonedEnd: zonedEnd
  };
};
/** @hidden */
var WeekView = WeekViewVue2;
export { WeekView, WeekViewVue2 };